import apiClient from 'utilities/apiClient';

export const detailsList = (payload) => {
  console.log('detailsList', payload);
  return apiClient.get(`${apiClient.Urls.listView}/${payload}`, payload, true);
};

// paymentList
export const paymentList = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.user_actions}/${url}`, payload, true);
};

export const invoiceData = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.payment}/${url}`,
    payload,
    true,
    'file'
  );
};
